/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
  TelegramTransactionsUserControllerGetActivePaymentSystems401,
} from '../../types/TelegramTransactionsUserControllerGetActivePaymentSystems.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramTransactionsUserGetActivePaymentSystems } from '../../methods/telegramTransactionsUserGetActivePaymentSystems.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramTransactionsUserGetActivePaymentSystemsQueryKey = () =>
  [{ url: '/api/user/telegram/transactions/active-payment-systems' }] as const;

export type TelegramTransactionsUserGetActivePaymentSystemsQueryKey = ReturnType<
  typeof telegramTransactionsUserGetActivePaymentSystemsQueryKey
>;

export function telegramTransactionsUserGetActivePaymentSystemsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramTransactionsUserGetActivePaymentSystemsQueryKey();
  return queryOptions<
    TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerGetActivePaymentSystems401>,
    TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramTransactionsUserGetActivePaymentSystems(config);
    },
  });
}

/**
 * {@link /api/user/telegram/transactions/active-payment-systems}
 */
export function useTelegramTransactionsUserGetActivePaymentSystems<
  TData = TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
  TQueryData = TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
  TQueryKey extends QueryKey = TelegramTransactionsUserGetActivePaymentSystemsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramTransactionsUserControllerGetActivePaymentSystemsQueryResponse,
        ResponseErrorConfig<TelegramTransactionsUserControllerGetActivePaymentSystems401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramTransactionsUserGetActivePaymentSystemsQueryKey();

  const query = useQuery(
    {
      ...telegramTransactionsUserGetActivePaymentSystemsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramTransactionsUserControllerGetActivePaymentSystems401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
